import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { TrendingUp } from 'lucide-react';

const IncidentTrendChart = () => {
  const data = [
    { month: 'Jul', nearMiss: 8, injury: 3, fatality: 0 },
    { month: 'Aug', nearMiss: 12, injury: 2, fatality: 0 },
    { month: 'Sep', nearMiss: 10, injury: 4, fatality: 0 },
    { month: 'Oct', nearMiss: 15, injury: 2, fatality: 1 },
    { month: 'Nov', nearMiss: 11, injury: 5, fatality: 0 },
    { month: 'Dec', nearMiss: 14, injury: 3, fatality: 0 }
  ];

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <TrendingUp className="w-5 h-5 text-blue-600" />
          <h3 className="text-lg font-semibold text-gray-900">Incident Trends</h3>
        </div>
      </div>
      
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
            <XAxis dataKey="month" stroke="#6b7280" />
            <YAxis stroke="#6b7280" />
            <Tooltip 
              contentStyle={{ 
                backgroundColor: '#fff', 
                border: '1px solid #e5e7eb',
                borderRadius: '8px'
              }}
            />
            <Legend />
            <Line 
              type="monotone" 
              dataKey="nearMiss" 
              stroke="#f59e0b" 
              name="Near Miss"
              strokeWidth={2}
              dot={{ fill: '#f59e0b', r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="injury" 
              stroke="#ef4444" 
              name="Injury"
              strokeWidth={2}
              dot={{ fill: '#ef4444', r: 4 }}
            />
            <Line 
              type="monotone" 
              dataKey="fatality" 
              stroke="#7c3aed" 
              name="Fatality"
              strokeWidth={2}
              dot={{ fill: '#7c3aed', r: 4 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default IncidentTrendChart;